import React, { Component } from "react";
import { Link } from 'react-router-dom'
import Accordion from 'react-bootstrap/Accordion'
import styled from 'styled-components'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import * as firebase from 'firebase';
import 'firebase/firestore'


const Styles = styled.div`
  .button {
    background-color: #000;
    margin: 3px
    border-color: #000
  }

  .card {
    align-items: center
  }
`;

export default class organizerRegistration extends Component {
    constructor(props) {
        super(props);


        this.state = {
            allEvents: [],    //used to display data
            myEvents: [],     //will be used to push data to other screens
            refresh: true,    //used to ensure data automatically loads
        };
    }


    render() {
        return (
            <Container>
                <Row style={{ justifyContent: 'center' }}>
                    <Button href="https://connect.stripe.com/express/oauth/authorize?redirect_uri=https://connect.stripe.com/connect/default/oauth/test&client_id=ca_Ew3askc7h3V3XqkzZVT56L2MZvlf0zKc&state={STATE_VALUE}">Stripe</Button>
                </Row>
            </Container>
        )
    }
}
